import { createSlice } from '@reduxjs/toolkit';
const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
const UPDATE_BASIC_DETAILS = 'UPDATE_BASIC_DETAILS'
const UPDATE_CV_LINKEDIN = 'UPDATE_CV_LINKEDIN';
const UPDATE_INTEREST = 'UPDATE_INTEREST';
const UPDATE_EMAIL = 'UPDATE_EMAIL';
const UPDATE_MOBILE = 'UPDATE_MOBILE';
const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
const UPDATE_FIRST_NAME = 'UPDATE_FIRST_NAME';
const UPDATE_LAST_NAME = 'UPDATE_LAST_NAME';
const UPDATE_GENDER = 'UPDATE_GENDER';
const UPDATE_DESIGNATION = 'UPDATE_DESIGNATION';
const UPDATE_STATE = 'UPDATE_STATE';
const UPDATE_CITY = 'UPDATE_CITY';
const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
const UPDATE_PROFILE = 'UPDATE_PROFILE';
const UPDATE_CV = 'UPDATE_CV';
const UPDATE_LINKEDIN = 'UPDATE_LINKEDIN';
const UPDATE_EDUCATION = 'UPDATE_EDUCATION';
const UPDATE_YEARS_OF_EXPERIENCE = 'UPDATE_YEARS_OF_EXPERIENCE';
const UPDATE_CURRENT_CTC = 'UPDATE_CURRENT_CTC';
const UPDATE_EXPECTED_CTC = 'UPDATE_EXPECTED_CTC';
const UPDATE_JOB_INDUSTRY = 'UPDATE_JOB_INDUSTRY';

const initialState = JSON.parse(window.sessionStorage.getItem('registrationFromData')) ?? {
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    mobile: '',
    gender: '',
    designation: '',
    location: '',
    city: '',
    country: '',
    handles: { linkedin: '' },
    preffered_job_types: [],
    profile: '',
    cv: {},
    education: '',
    years_of_experience: 0,
    current_ctc: 0,
    expected_ctc: 0,
    job_industry: '',
    currentRegistrationStep: 'onboarding_one',
}

const registrationSteps = [
    'onboarding_one',
    'onboarding_two',
    'onboarding_three',
    'onboarding_four',
    'onboarding_five',
    'onboarding_six',
    'onboarding_seven',
    'onboarding_eight',
];

const registrationStates = createSlice({
    name: 'registrationData',
    initialState,
    reducers: {
        updateRegistrationStates:
            (state, action) => {

                const type = action.payload.type;
                const value = action.payload.payload;

                switch (type) {
                    case UPDATE_PROFILE_IMAGE: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, profile: value }));
                        return { ...state, profile: value };
                    };
                        break;
                    case UPDATE_BASIC_DETAILS: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, ...value }));
                        return { ...state, ...value };
                    };
                        break;
                    case UPDATE_CV_LINKEDIN: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, ...value }));
                        return { ...state, ...value };
                    };
                        break;
                    case UPDATE_INTEREST: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, preffered_job_types: value }));
                        return { ...state, preffered_job_types: value };
                    };
                    case UPDATE_PASSWORD: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, password: value }));
                        return { ...state, password: value };
                    };
                    case UPDATE_EMAIL: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, email: value }));
                        return { ...state, email: value };
                    };
                    case UPDATE_FIRST_NAME: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, first_name: value }));
                        return { ...state, first_name: value };
                    };
                    case UPDATE_LAST_NAME: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, last_name: value }));
                        return { ...state, last_name: value };
                    };
                    case UPDATE_GENDER: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, gender: value }));
                        return { ...state, gender: value };
                    };
                    case UPDATE_DESIGNATION: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, designation: value }));
                        return { ...state, designation: value };
                    };
                    case UPDATE_STATE: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, location: value }));
                        return { ...state, location: value };
                    };
                    case UPDATE_CITY: {
                        const updatedState = {...state,city: value};

                        window.sessionStorage.setItem(
                            'registrationFromData',
                            JSON.stringify(updatedState)
                        );

                        return updatedState;
                    };
                    case UPDATE_COUNTRY: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, country: value }));
                        return { ...state, country: value };
                    };
                    case UPDATE_MOBILE: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({...state, mobile: value}));
                        return { ...state, mobile: value};
                    }
                    case UPDATE_CV: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, cv: value }));
                        return { ...state, cv: value };
                    };
                    case UPDATE_LINKEDIN: {
                        const handles = { ...state.handles, linkedin: value };
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, handles }));
                        return { ...state, handles };
                    };
                    case UPDATE_EDUCATION: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({...state, education: value}));
                        return { ...state, education: value}
                    }
                    case UPDATE_YEARS_OF_EXPERIENCE: {
                        const experience = Number(value);

                        window.sessionStorage.setItem(
                            'registrationFromData',
                            JSON.stringify({
                                ...state,
                                years_of_experience: experience
                            })
                        );

                        return {
                            ...state,
                            years_of_experience: experience
                        };
                    }
                    case UPDATE_CURRENT_CTC: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, current_ctc: value }));
                        return { ...state, current_ctc: value };
                    };
                    case UPDATE_EXPECTED_CTC: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, expected_ctc: value }));
                        return { ...state, expected_ctc: value };
                    };
                    case UPDATE_JOB_INDUSTRY: {
                        window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, job_industry: value }));
                        return { ...state, job_industry: value };
                    };
                        break;
                    default: { return { ...state } };

                };

            },
        updateCurrentRegistrationStep: (state, action) => {
            const oldIndex = registrationSteps.indexOf(state.currentRegistrationStep);
            const newIndex = registrationSteps.indexOf(action.payload);

            if (newIndex > oldIndex) {
                const newStep = action.payload;
                window.sessionStorage.setItem('registrationFromData', JSON.stringify({ ...state, currentRegistrationStep: newStep }));
                return { ...state, currentRegistrationStep: newStep };
            }

        }
    }
}
);

export const { updateRegistrationStates, updateCurrentRegistrationStep } = registrationStates.actions;
export default registrationStates.reducer;
